import { useEffect } from 'react';

import { PLANS } from 'global/plans';
import { useCompanyInfo, useUserInfo } from 'store/useUserStore';

export function useUserGuiding() {
  const userInfo = useUserInfo();
  const companyInfo = useCompanyInfo();

  // Converting from UTC to UNIX time
  const convertedCreatedAt = new Date(0); // The 0 there is the key, which sets the date to the epoch
  convertedCreatedAt.setUTCSeconds(userInfo?.createdAt ?? 0);

  useEffect(() => {
    if (userInfo?.roleId === 1) {
      if ((window as any)?.userGuiding) {
        (window as any).userGuiding?.identify(userInfo?.user_identifier, {
          name: `${userInfo?.firstName} ${userInfo?.lastName}`,
          email: userInfo?.user_identifier,
          is_free_trial: (companyInfo?.plan as string)?.toLowerCase() === PLANS.freeTrial,
          signed_up_at: convertedCreatedAt?.toISOString(),
          subscription: companyInfo?.subscription,
          user_role: userInfo?.roleId,
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);
}
